import axios from '@/utils/request'
const urlPrefix = 'map'

// 新建地图样式
export function addMapStyle (data) {
  return axios({
    url: urlPrefix + '/map/style',
    method: 'post',
    data: data
  })
}

// 编辑地图样式
export function editMapStyle (data) {
  return axios({
    url: urlPrefix + '/map/style',
    method: 'PUT',
    data: data
  })
}

export function getMapStyle (data) {
  return axios({
    url: urlPrefix + '/map/style',
    method: 'GET',
    params: data
  })
}
